import { ListItem, ListItemText } from 'material-ui'
import List from 'material-ui/List'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import styleSheet from './AllWebChatStyle.style'

class WebChatBotChoice extends React.Component {
  render() {
    const { answerChoices } = this.props
    const classes = this.props.classes

    return (
      <div>
        <Typography type="caption" className={classes.botChoice_subTitle}>
          以下の中から選択してください
        </Typography>
        <div className={classes.botChoice_content}>
          <List>
            {answerChoices &&
              answerChoices.map((choice, index) => {
                let location = true
                if (choice.id == '772') {
                  location = this.props.current_longitude != '' && this.props.current_latitude != ''
                }
                const currentButton = location ? classes.botChoice_userChoise : classes.botChoice_faildGetLocation
                const currentColor = location ? classes.textBlue : classes.textGray
                const currentClick =
                  location ?
                    () => this.props.sendAnswer(choice)
                  : () =>
                      alert(
                        `位置情報が取得できていません。\n\nこのサイトでの位置情報の使用を許可し、ページを更新してください。`
                      )

                return (
                  <ListItem key={`${index}-${choice}`} onClick={currentClick} className={`${currentButton} btn`}>
                    <ListItemText
                      primary={
                        <Typography type="caption" className={`${currentColor} text-center`}>
                          {choice.option_text}
                        </Typography>
                      }
                    />
                  </ListItem>
                )
              })}
          </List>
        </div>
      </div>
    )
  }
}

export default withStyles(styleSheet)(WebChatBotChoice)
